export const PLAYERBOARDS = {
  ALCHEMIST_SPEC: {
    offset: [0, 0],
  },
  ALCHEMIST_GEN: {
    offset: [0, 1],
  },
  ASSASSIN_SPEC: {
    offset: [0, 2],
  },
  ASSASSIN_GEN: {
    offset: [1, 0],
  },
  NOBLEMAN_SPEC: {
    offset: [1, 1],
  },
  NOBLEMAN_GEN: {
    offset: [1, 2],
  },
  MERCHANT_SPEC: {
    offset: [2, 0],
  },
  MERCHANT_GEN: {
    offset: [2, 1],
  },
  IRONCLAD_SPEC: {
    offset: [2, 2],
  },
  IRONCLAD_GEN: {
    offset: [3, 0],
  },
  ROGUE_SPEC: {
    offset: [3, 1],
  },
  ROGUE_GEN: {
    offset: [3, 2],
  },
};

export const PLAYERBOARD_MAP = [
  { front: "ALCHEMIST_GEN", back: "ALCHEMIST_SPEC" },
  { front: "ASSASSIN_GEN", back: "ASSASSIN_SPEC" },
  { front: "NOBLEMAN_GEN", back: "NOBLEMAN_SPEC" },
  { front: "MERCHANT_GEN", back: "MERCHANT_SPEC" },
  { front: "IRONCLAD_GEN", back: "IRONCLAD_SPEC" },
  { front: "ROGUE_GEN", back: "ROGUE_SPEC" },
];
